export default __webpack_public_path__ + "static/media/pre-icon.a1a6294c.svg";